import { SSG_CONFIRM_MAIL } from '../types/types';

export const confirmMail = email => {
  return {
    type: SSG_CONFIRM_MAIL,
    payload: { email: email }
  };
};
